import {Button, Stack, Alert, IconButton} from '@mui/material';
import Layout from "../../../Frames/Layout";
import { useQuery} from 'react-query';
import { Link } from 'react-router-dom';
import DPC from '../../../../services/API/DPC';
import useOptimisticDelete from '../../../../services/ReactQuery/useOptimisticDelete';
import ListIcon from '@mui/icons-material/FormatListNumbered';
import { Add, Check, Close, Delete, Edit } from '@mui/icons-material';
import Grid from '../../../Tools/Grid';


export default function List(){

    const {data, isSuccess, isError } = useQuery('dpc_actions', () => DPC.getActions().then(r => r.data));

    const deleteAction = useOptimisticDelete('dpc_actions', DPC.deleteAction)

    const columns = [
        {
            field: 'id',
            headerName: 'Référence',
            width: 140,
            type: 'string',
            valueGetter: p => p.row.id
        },
        {
            field: 'title',
            headerName: 'Nom',
            width: 400,
            type: 'string',
            valueGetter: p => p.row.title
        },
        {
            field: 'year',
            headerName: 'Année',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.year
        },
        {
            field: 'duration',
            headerName: 'Durée',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.duration,
            renderCell: p => 
                <span>{p.value.toLocaleString()}<small>h</small></span>
        },
        {
            field: 'sessionsCount',
            headerName: 'Sessions',
            width: 90,
            type: 'number',
            valueGetter: p => p.row.sessionsCount,
            renderCell: p => 
                <Button
                    variant='outlined'
                    component={Link}
                    to={`/admin/dpc/actions/${p.row.id}/sessions`}
                    size='small'
                >
                    {(p.value || 0).toLocaleString()}
                </Button>
        },
        {
            field: 'registrantsCount',
            headerName: 'Inscrits',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.registrantsCount
        },
        {
            field: 'revenue',
            headerName: 'Revenu',
            width: 90,
            type: 'number',
            valueGetter: p => p.row.revenue,
            renderCell: p => 
                <span>{(p.value || 0).toLocaleString()}<small>€</small></span>
        },
        {
            field: 'pi',
            headerName: 'P.I.',
            width: 60,
            type: 'boolean',
            valueGetter: p => p.row.type?.id === 'pi',
            renderCell: p => p.value ?
                <Check color='info'/> :
                <Close color='error'/>
        },
        {
            field: 'plan',
            headerName: 'Déroulé',
            width: 80,
            type: 'string',
            valueGetter: p => p.row.id,
            renderCell: p => 
                <IconButton
                    component={Link}
                    to={`/admin/dpc/actions/${p.value}/plan`}
                    size="small"
                >
                    <ListIcon/>
                </IconButton>
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100,
            type: 'string',
            valueGetter: p => p.row.id,
            renderCell: p => 
                <Stack direction='row'>
                    <IconButton
                        component={Link}
                        to={'/admin/dpc/actions/' + p.value}
                        size="small"
                    >
                        <Edit/>
                    </IconButton>
                    <IconButton 
                        onClick={() => handleDelete(p.value)}
                        size="small"
                    >
                        <Delete />
                    </IconButton>
                </Stack>
            },
    ];


    const handleDelete = id => {
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer cette action ?");
        if(!ok) return false;
        return deleteAction.mutate(id);
    }

    return <Layout title="Actions DPC" tab="dpc" menu="admin">

        <Button 
            variant='contained' 
            sx={{mb: 1}}
            startIcon={<Add />}
            component={Link}
            to="/admin/dpc/actions/new"
        >
            Ajouter
        </Button>

        {isError && 
            <Alert severity="error">
                Une erreur s'est produite. Les données n'ont pas pu être récupérées.
            </Alert>
        }

        <Grid
            id={`dpcActionsGrid`}
            columns={columns}
            rows={isSuccess ? data : null}
            toolbar
        />

    </Layout>
}




